export const RESERVATION_SCHEDULE_VIEW_TEST_ID = 'reservationScheduleView';

export const SEND_FEEDBACK_BUTTON_ID = 'send-feedback-button';
export const SIGN_IN_BUTTON_ID = 'sign-in-button';
export const LEARN_MORE_BUTTON_ID = 'learn-more-button';
export const REGISTER_BUTTON_ID = 'register-button';
export const SEND_BUTTON_ID = 'send-button';
export const JUMP_TO_TODAY_BUTTON_ID = 'jump-to-today-button';
export const CREATE_RESERVATION_BUTTON_ID = 'create-reservation-button';
export const PENDING_RESERVATION_BUTTON_ID = 'pending-reservation-button';
export const TAKE_SUGGESTION_BUTTON_ID = 'take-suggestion-button';
export const NEW_RESERVATION_BUTTON_ID = 'new-reservation-button';
export const EDIT_RESERVATION_BUTTON_ID = 'edit-reservation-button';
export const EDIT_RESERVATION_BUTTON_OPTIONS_ID = 'edit-reservation-button-options';
export const GUEST_ARRIVED_BUTTON_ID = 'guest-arrived-button';
export const DELETE_BUTTON_ID = 'delete-button';
export const ACCEPT_BUTTON_ID = 'accept-button';
export const REJECT_BUTTON_ID = 'reject-button';
export const LAYOUT_BUTTON_ID = 'layout-button';
export const ADD_LAYOUT_BUTTON_ID = 'add-layout-button';
export const REACTIVATE_BUTTON_ID = 'reactivate-button';

export const APP_GUEST_ICON_ID = 'app-guest-icon';
export const APP_PLACE_ICON_ID = 'app-place-icon';

export const DATE_PICKER_ID = 'date-picker';

export const LOGO_ID = 'logo';

export const MANAGE_RESERVATIONS_MESSAGE_ID = 'manage-reservations-message';

export const RESERVATION_CARD_MENU_ID = 'reservation-card-menu';
export const SIGN_OUT_MENU_ITEM_ID = 'sign-out-menu-item';
export const HOURS_MENU_ITEM_ID = 'hours-menu-item';
export const RESERVATIONS_MENU_ITEM_ID = 'reservations-menu-item';
export const LAYOUT_MENU_ITEM_ID = 'layout-menu-item';
export const PLACE_SELECTION_MENU_ITEM_ID = 'place-selection-menu-item';
export const GUEST_BOOK_MENU_ITEM_ID = 'guest-book-menu-item';
export const SETTINGS_MENU_ITEM_ID = 'settings-menu-item';
export const PICTURES_MENU_ITEM_ID = 'pictures-menu-item';
export const CHATBOT_MENU_ITEM_ID = 'chatbot-menu-item';
export const AUTOMATIC_RESERVATION_MENU_ITEM_ID = 'automatic-reservation-menu-item';
export const EMPLOYEES_MENU_ITEM_ID = 'employees-menu-item';
export const PERMISSIONS_MENU_ITEM_ID = 'permissions-menu-item';
export const ACCOUNT_MENU_ITEM_ID = 'account-menu-item';
export const PLACE_MENU_ITEM_ID = (index: number) => `place-${index}-menu-item`;

export const CREATE_RESERVATION_SIDE_SHEET_ID = 'create-reservation-side-sheet';
export const EDIT_RESERVATION_SIDE_SHEET_ID = 'edit-reservation-side-sheet';
export const PENDING_RESERVATION_SIDE_SHEET_ID = 'pending-reservation-side-sheet';
export const IMAGE_ID = 'image';

export const FIRST_NAME_INPUT_ID = 'first-name-input';
export const LAST_NAME_INPUT_ID = 'last-name-input';
export const PHONE_NUMBER_INPUT_ID = 'phone-number-input';
export const EMAIL_INPUT_ID = 'email-input';
export const GUEST_NUMBER_INPUT_ID = 'guest-number-input';
export const WEBSITE_INPUT_ID = 'website-input';
export const PASSWORD_INPUT_ID = 'password-input';
export const CONFIRM_PASSWORD_INPUT_ID = 'confirm-password-input';
export const COMPANY_NAME_INPUT_ID = 'company-name-input';
export const COMPANY_VAT_INPUT_ID = 'company-vat-input';
export const TABLE_INPUT_ID = 'table-input';

export const RESERVATION_CARD_ID = 'reservation-card';
export const PENDING_RESERVATION_CARD_ID = 'pending-reservation-card';
export const SWITCH_ID = 'switch';
export const SUBSCRIPTION_CARD_ID = 'subscription-card';
export const PRICE_CARD_ID = 'price-card';

export const NO_HOURS_PAGE_ID = 'no-hours-page';

export const REGISTRATION_CONFIRMATION_MESSAGE_ID = 'registration-confirmation-message';

export const FORGOT_PASSWORD_LINK_ID = 'forgot-password-link';

export const LOADING_INDICATOR_ID = 'loading-indicator';

export const BLACKOUT = 'blackout';

export const RESERVATION_SCHEDULE_CONTENT = 'reservation-schedule-content';
